import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db, auth } from '../../Firebase/Firebase';
import { doc, getDoc, collection, query, where, getDocs, updateDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import {
  FaInstagram, FaFacebook, FaTwitter, FaLinkedin, FaTiktok, FaYoutube,
  FaWhatsapp, FaTelegramPlane, FaGlobe, FaPhoneAlt, FaEnvelope
} from 'react-icons/fa';
import './PerfilNegocioPublico.css';
import Navbar from '../../Components/NavBarAirbnbStyle';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import SmartConnectQR from './SmartConnect/smartConnectQR';
import NavbarMobileVersion from '../../Components/NavBar/NavBarMobileVersion';
import Logo from '../../images/Logo.png';
const iconosRedes = {
  instagram: <FaInstagram />,
  facebook: <FaFacebook />,
  twitter: <FaTwitter />,
  linkedin: <FaLinkedin />,
  tiktok: <FaTiktok />,
  youtube: <FaYoutube />,
  whatsapp: <FaWhatsapp />,
  telegram: <FaTelegramPlane />,
  web: <FaGlobe />,
};

const BusinessProfileView = () => {
  const { uid } = useParams();
  const navigate = useNavigate();

  const [perfil, setPerfil] = useState(null);
  const [usuarioData, setUsuarioData] = useState({});
  const [redes, setRedes] = useState({});
  const [servicios, setServicios] = useState([]);
  const [esPropietario, setEsPropietario] = useState(false);
  const [rutaInputVisible, setRutaInputVisible] = useState(false);
  const [nombreRuta, setNombreRuta] = useState('');

  useEffect(() => {
    const cargarDatos = async () => {
      if (!uid) return;

      // Obtener datos del perfil
      const userRef = doc(db, 'usuarios', uid);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setPerfil(data.perfilNegocio || {});
        setUsuarioData(
          data || {}
        );
        setRedes(data.redes || {});
      }

      // Servicios
      const serviciosRef = collection(db, 'servicios');
      const q = query(serviciosRef, where('uid', '==', uid));
      const querySnapshot = await getDocs(q);
      const serviciosArray = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setServicios(serviciosArray);
    };

    // Comparar UID del dueño
    onAuthStateChanged(auth, (user) => {
      if (user?.uid === uid) {
        setEsPropietario(true);
      }
    });

    cargarDatos();
  }, [uid]);

  const handleEditarPerfil = () => {
    navigate(`/crear-perfil-negocio`);
  };
  const [modalVisible, setModalVisible] = useState(false);

  const iniciarSmartConnect = () => {
    setModalVisible(false);
    const defaultURL = (perfil.nombre || "mi-perfil").replace(/\s+/g, "_");
    setNombreRuta(defaultURL);
    setRutaInputVisible(true); // muestra el input
  };


  const handleAccionSmartConnect = async () => {
    if (usuarioData.coins < 200) {
      setModalVisible(false);
      setRutaInputVisible(false);
      toast.error(
        <div>
          <p>No tienes suficientes monedas para activar Smart-Connect.</p>
          <p>Saldo Actual {usuarioData.coins} coins</p>
          <button
            onClick={() => {
              window.location.href = "/coin-purchase";
            }}
            style={{
              background: "#007bff",
              color: "#fff",
              border: "none",
              padding: "6px 12px",
              borderRadius: "4px",
              marginTop: "8px",
              cursor: "pointer"
            }}
          >
            Comprar Coins
          </button>
        </div>,
        { autoClose: false }
      );
      return;
    }

    const nombreURL = nombreRuta.trim().replace(/\s+/g, "_");

    if (!nombreRuta) {
      toast.warning("No se activó Smart-Connect. Ruta personalizada cancelada.");
      return;
    }
    try {
      const q = query(
        collection(db, "usuarios"),
        where("nombreURL", "==", nombreURL)
      );
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty && querySnapshot.docs[0].id !== uid) {
        toast.error(`❌ La URL personalizada "${nombreURL}" ya está en uso. Por favor elige otra.`);
        return;
      }
      const userRef = doc(db, 'usuarios', uid);
      await updateDoc(userRef, {
        coins: usuarioData.coins - 200,
        smartConnectActive: true,
        nombreURL: nombreURL

      });
      setUsuarioData(await getDoc(userRef));
      toast.success(
        <div>
          <p>Smart-Connect activado correctamente.</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: "#28a745",
              color: "#fff",
              border: "none",
              padding: "6px 12px",
              borderRadius: "4px",
              marginTop: "8px",
              cursor: "pointer"
            }}
          >
            Recargar Página
          </button>
        </div>,
        { autoClose: false }
      );

    } catch (e) {
      console.log(e);
    }
    // Si tiene suficientes coins

    setModalVisible(false);
  };
const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) return JSON.parse(saved);
    } catch (error) {
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;
    return prefersDark || isNight;
  });

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

  if (!perfil) return <p className="text-center mt-10">Cargando perfil...</p>;

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <div className="fb_perfil_contenedor">
        <div className="fb_perfil_portada"></div>

        <div className="fb_perfil_foto-grande">
          <img src={perfil.fotoURL || Logo} alt="Perfil" />
        </div>
        <div className="fb_perfil_contenido">
          <div className="fb_perfil_encabezado">
            <h1>{perfil.nombre}</h1>
            <p className="fb_perfil_tipo">{perfil.tipo === 'marca' ? 'Marca / Emprendimiento' : 'Persona'}</p>
            {esPropietario && (
              <>
                <button className="fb_perfil_boton-editar" onClick={handleEditarPerfil}>
                  Editar Perfil
                </button>
                {
                  usuarioData.smartConnectActive ? (
                    <div className="smartconnect-container">

                      <div className="smartconnect-buttons">
                        <SmartConnectQR nombreURL={usuarioData.nombreURL} />
                      </div>
                    </div>

                  ) : (
                    <button className="fb_perfil_boton-editar" onClick={() => setModalVisible(true)}>
                      Adquirir mi Smart-Connect
                    </button>
                  )
                }

              </>


            )}
          </div>

          <div className="fb_perfil_layout">
            {/* Columna izquierda */}
            <div className="fb_perfil_columna-izquierda">
              <div className="fb_perfil_card">
                <h2>Información de contacto</h2>
                {
                  usuarioData.smartConnectActive && (
                    <a href={`https://smart-connect.laofi.work/${usuarioData.nombreURL}`} target="_blank" rel="noopener noreferrer">
                      Smart-Connect {usuarioData.nombreURL}
                    </a>
                  )
                }
                <h2>Smart-Connect</h2>
                
                <p><FaEnvelope /> {usuarioData.email}</p>
                <p><FaPhoneAlt /> {perfil.telefono}</p>
                <p><strong>Fecha de nacimiento:</strong> {usuarioData.fechaNacimiento}</p>
                <p><strong>Descripción:</strong> {perfil.descripcion}</p>
              </div>

              <div className="fb_perfil_card">
                <h2>Redes Sociales</h2>
                <ul className="fb_perfil_redes">
                  {Object.entries(redes).map(([key, valor]) => (
                    <li key={key}>
                      {iconosRedes[key]}{' '}
                      {valor.startsWith('http') ? (
                        <a href={valor} target="_blank" rel="noopener noreferrer">{valor}</a>
                      ) : (
                        <span>{valor}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Columna derecha: servicios como publicaciones */}
            <div className="fb_perfil_columna-derecha">
              {servicios.length === 0 ? (
                <p>Este perfil aún no tiene servicios publicados.</p>
              ) : (
                servicios.map(servicio => (

                  <div key={servicio.id} className="fb_perfil_card fb_perfil_card-servicio">
                    {esPropietario && (
                      <>
                        <button className="fb_perfil_boton-editar" onClick={() => window.location.href = `/editar-servicio/${servicio.id}`}
                        >
                          Editar Servicio
                        </button>



                      </>


                    )}
                    <h3>{servicio.nombre}</h3>
                    <p>{servicio.descripcion}</p>
                    {servicio.imagenURL && (
                      <img src={servicio.imagenURL} alt={servicio.nombre} />
                    )}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      {modalVisible && (
        <div className="fb_perfil_modal_overlay">
          <div className="fb_perfil_modal">
            <h2>¿Qué es Smart-Connect?</h2>
            <p>
              Smart-Connect es tu identidad digital personalizada que te permite conectar todos tus servicios, redes sociales
              y datos de contacto en un solo lugar. Ideal para marcas, emprendedores y profesionales.
            </p>
            <span> Por solo 200 coins por tiempo limitado, puedes activar tu Smart-Connect y acceder a todas tus redes sociales, servicios y datos de contacto en un solo lugar.</span>

            <div className="fb_perfil_modal_acciones">
              <button onClick={iniciarSmartConnect} className="fb_perfil_boton-accion">
                Activar ahora
              </button>
              <button onClick={() => setModalVisible(false)} className="fb_perfil_boton-cerrar">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
      {rutaInputVisible && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>✨ Personaliza tu ruta para Smart-Connect</h3>
            <p>¿Cómo quieres que se vea tu URL personalizada?</p>
            <input
              type="text"
              value={nombreRuta}
              onChange={(e) => setNombreRuta(e.target.value)}
              style={{ padding: '8px', width: '100%', marginTop: '10px' }}
            />
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={() => setRutaInputVisible(false)} style={{ marginRight: '10px' }}>
                Cancelar
              </button>
              <button onClick={handleAccionSmartConnect}>Activar</button>
            </div>
          </div>
        </div>
      )}
      {rutaInputVisible && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>✨ Personaliza tu ruta para Smart-Connect</h3>
            <p>¿Cómo quieres que se vea tu URL personalizada?</p>
            <input
              type="text"
              value={nombreRuta}
              onChange={(e) => setNombreRuta(e.target.value)}
              style={{ padding: '8px', width: '100%', marginTop: '10px' }}
            />
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={() => setRutaInputVisible(false)} style={{ marginRight: '10px' }}>
                Cancelar
              </button>
              <button onClick={handleAccionSmartConnect}>Activar</button>
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default BusinessProfileView;
